import * as React from 'react'
import {
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
} from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'

export enum DiagnosticType {
  Root,
  NebulaLogs,
  NebulaLogLevels,
  OrleansDashboard,
  ImportConfiguration,
  Database,
  LocationSharing,
  BlueGreen,
  CertificateConfiguration,
  SupportFederatedAuthenticationConfiguration,
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    section: {
      marginTop: 16,
      marginLeft: 16,
      width: 400,
    },
    sectionContent: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      padding: 0,
    },
    sectionTitle: {
      marginTop: 16,
      marginLeft: 16,
      marginBottom: 16,
    },
    sectionDescription: {
      marginLeft: 16,
      marginBottom: 16,
      fontSize: 14,
      opacity: 0.54,
    },
    sectionAction: {
      marginTop: 16,
      marginLeft: 8,
      marginBottom: 8,
    },
  }),
)

interface DiagnosticsCardProps {
  title: string
  description: string
  onEdit: (type: DiagnosticType) => void
  editText?: string
  type: DiagnosticType
  children?: (className: string) => JSX.Element
}

export const DiagnosticCard: React.FunctionComponent<DiagnosticsCardProps> = ({
  title,
  description,
  onEdit,
  editText = 'Edit',
  type,
  children,
}) => {
  const classes = useStyles({})

  const onEditClicked = React.useMemo(() => {
    return (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      return onEdit(type)
    }
  }, [onEdit, type])

  return (
    <Card className={classes.section}>
      <CardContent className={classes.sectionContent}>
        <Grid container direction="column">
          <Grid item>
            <Typography className={classes.sectionTitle}>{title}</Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.sectionDescription}>
              {description}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Button
          className={classes.sectionAction}
          color="primary"
          onClick={onEditClicked}
        >
          {editText}
        </Button>
        {children && children(classes.sectionAction)}
      </CardActions>
    </Card>
  )
}
